import * as React from 'react';
import { clsx } from 'clsx';
import { useDeviceType } from '../../../../responsive';
import { CloseButton } from '../../../../internal/components/CloseButton';
import { Overlay } from '../../../internal/components';
import { getStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const modalWindowViewDefaultProps = {
  size: 'M',
  fixed: false,
  outside: true,
  print: true,
  hideCloseButton: false
};

/**
 * Компонент для рендера модального окна в виде окошка с крестиком внутри
 */
export function ModalWindowView(props) {
  const {
    children,
    onClose,
    size = modalWindowViewDefaultProps.size,
    fixed = modalWindowViewDefaultProps.fixed,
    outside = modalWindowViewDefaultProps.outside,
    print = modalWindowViewDefaultProps.print,
    hideCloseButton = modalWindowViewDefaultProps.hideCloseButton,
    content,
    header,
    footer,
    title,
    width,
    height,
    maxWidth,
    maxHeight,
    zIndex
  } = props;
  const deviceType = useDeviceType();
  const styles = getStyles(deviceType, size);
  return /*#__PURE__*/_jsx(Overlay, {
    zIndex: zIndex,
    onClose: onClose,
    outside: outside,
    print: print,
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(styles['container'], styles[size], fixed && styles['fixed'], !!header && styles['withHeader']),
      style: {
        width,
        height,
        maxWidth,
        maxHeight
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: styles['window'],
        "aria-modal": "true",
        role: "dialog",
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles['head'],
          children: [!hideCloseButton && /*#__PURE__*/_jsx(CloseButton, {
            className: styles['close'],
            onClick: onClose,
            size: 16,
            theme: "dark"
          }), title && /*#__PURE__*/_jsx("div", {
            className: clsx(styles['title']),
            children: title
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles['body'],
          children: [header && /*#__PURE__*/_jsx("div", {
            className: styles['header'],
            children: header
          }), /*#__PURE__*/_jsx("div", {
            className: styles['content-container'],
            children: children || /*#__PURE__*/_jsx("div", {
              className: styles['content'],
              children: content
            })
          }), footer && /*#__PURE__*/_jsx("div", {
            className: styles['footer'],
            children: footer
          })]
        })]
      })
    })
  });
}